// src/pages/Publisher/Gamics/components/GamTableRow.tsx
import React from 'react';
import { Gamic } from '../types';
import StatusBadge from '@/components/StatusBadge';
import MoreMenu from '@/components/MoreMenu';
import RemoteFile from '@/helper/RemoteFile';

interface Props {
  gamic: Gamic;
  idx: string;
  anchorEl: HTMLElement | null;
  rowIdx: string | null;
  onMenuOpen(e: React.MouseEvent<HTMLElement>, idx: string): void;
  onMenuClose(): void;
  onDelete(idx: string): void;
  onArchive(idx: string): void;
}

  interface FormatLocal {
    (isoString: string): string;
  }

  const formatLocal: FormatLocal = (isoString: string): string => {
    const d = new Date(isoString);
    const opts: Intl.DateTimeFormatOptions = {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
    };
    return d.toLocaleDateString(undefined, opts);
  };

const GamTableRow: React.FC<Props> = ({
  gamic,
  idx,
  anchorEl,
  rowIdx,
  onMenuOpen,
  onMenuClose,
  onDelete,
  onArchive,
}) => (
  <tr
    className={`border-b ${
      ['Pending', 'Rejected'].includes(gamic.status) ? 'text-[#4D4D4D]' : ''
    }`}
  >
    <td className='p-2'>
      <RemoteFile
        className='h-[84px] w-[56px] object-cover rounded'
        keyPath={gamic.image_url}
        alt={gamic.title}
      />
    </td>
    <td className='p-4'>{gamic.title}</td>
    <td className='p-4 whitespace-nowrap'>{formatLocal(gamic.created_at)}</td>
    <td className='p-4'>{gamic.categories.join(', ')}</td>
    <td className='p-4'>{gamic.engagements}</td>
    <td className='p-4'>{gamic.downloads}</td>
    <td className='p-4'>{gamic.wishlists}</td>
    <td className='p-4'>{gamic.likes}</td>
    <td className='p-4'>{gamic.shares}</td>
    <td className='p-4'>{gamic.comments}</td>
    <td className='p-4'>
      <StatusBadge status={gamic.status} />
    </td>
    <td className='p-4'>
      <MoreMenu
        anchorEl={anchorEl}
        open={Boolean(anchorEl) && rowIdx === idx}
        onOpen={onMenuOpen}
        onClose={onMenuClose}
        rowIdx={rowIdx}
        idx={idx}
        onDelete={onDelete}
        onArchive={onArchive}
      />
    </td>
  </tr>
);

export default GamTableRow;
